import React from 'react';
import './WhyUs.css';

import { Heading } from '../../../components';
import { whyChooseUs } from '../../../constants';
import { useTranslation } from 'react-i18next';  // Hook for translations


const WhyUs = () => {
  const { t } = useTranslation();  // Initialize translation hook
  return (
    <section className='whyUs linear-bg'>

      <div className='box-container'>

        <div className='content'>
          
          {/* Section Heading */}
          <Heading title={t(whyChooseUs.heading)} subTitle={t(whyChooseUs.sub)} sideHeading linear />
          
          {/* Section Description */}
          <p>{t(whyChooseUs.description)}</p>
          
          {/* List of Reasons Why to Choose Us */}
          <ul className='whyUs-points'> 

            {whyChooseUs.points.map(point => {
              return  (
                /* Each List Item Representing a Reason */
                <li key={point.id}>
                  
                  {/* Icon Representing the Feature */}
                  <div className='icon'>{point.icon}</div>
                  
                  {/* Title and Description of the Feature */}
                  <div className='text'>
                    <h5>{t(point.title)}</h5>
                    <p>{t(point.content)}</p>
                  </div>
                </li>
              )
            })}

          </ul>

        </div>

      </div>
    </section>
  );
};

export default WhyUs;